import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAKRkiEsZkZHHKzBM2fTzuwDGKLg2VFV58",
  authDomain: "tbwc-c944e.firebaseapp.com",
  projectId: "tbwc-c944e",
  storageBucket: "tbwc-c944e.firebasestorage.app",
  messagingSenderId: "292023875231",
  appId: "1:292023875231:web:f8956183a36deb80da54aa",
  measurementId: "G-R91JG1E5WG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Analytics
export const analytics = getAnalytics(app);
export const logFirebaseEvent = logEvent;

// Initialize Firestore
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache(
    /*settings*/ { tabManager: persistentMultipleTabManager() }
  ),
});
